import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { getNotice } from "../db";

interface Props {
  positionStatic?: boolean;
}

const Notice = ({ positionStatic }: Props) => {
  const [notice, setNotice] = useState("");

  useEffect(() => {
    const asyncFunc = async () => {
      const noticeData = await getNotice();
      setNotice(noticeData?.content);
    };

    asyncFunc();
  }, []);

  return (
    <Container $positionStatic={!!positionStatic}>
      <Title>공지 | </Title>
      <div>
        {notice.split("<br/>").map((c, idx) => (
          <div key={idx}>{c}</div>
        ))}
      </div>
    </Container>
  );
};

export default Notice;

const Container = styled.div<{ $positionStatic: boolean }>`
  position: ${({ $positionStatic }) =>
    $positionStatic ? "static" : "absolute"};
  top: 0;
  left: 0;

  padding: 8px;

  width: 100%;

  box-sizing: border-box;

  border-bottom: 1px dashed #bebebe;

  display: flex;

  align-items: flex-start;

  gap: 4px;
`;

const Title = styled.div`
  white-space: nowrap;
`;
